import { useCallback, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import GlobalLoader from "./GlobalLoader";
import ProductModal from "./ProductModal";
import Modal from "./Modal";
import productLabels from "../data/productLabels";
import productDescriptions from "../data/productDescriptions";
import "./css/all-products.css";
import "./css/download-button.css";

const imagesContext = require.context("../img/cat_prod", true, /\.(png|jpe?g|gif|webp)$/i);

const buildProducts = () => {
  const folders = {};

  imagesContext.keys().forEach((key) => {
    const normalized = key.replace("./", "");
    const [folder, filename] = normalized.split("/");
    if (!folder || !filename || folder.toLowerCase().startsWith("informaci")) {
      return;
    }
    if (!folders[folder]) {
      folders[folder] = [];
    }
    folders[folder].push({ key: normalized, src: imagesContext(key) });
  });

  return Object.keys(folders)
    .map((folder) => {
      const sortedImages = folders[folder]
        .sort((a, b) => a.key.localeCompare(b.key, undefined, { numeric: true, sensitivity: "base" }))
        .map((entry) => entry.src);
      return {
        id: folder,
        label: productLabels[folder] || folder.replace(/_/g, " "),
        images: sortedImages,
        description: productDescriptions[folder] || productDescriptions.default
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label, "es", { sensitivity: "base" }));
};

const products = buildProducts();

const AllProductsPage = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const openProductModal = useCallback((product) => {
    setSelectedProduct(product);
    setSelectedImageIndex(0);
  }, []);

  const closeProductModal = useCallback(() => {
    setSelectedProduct(null);
    setSelectedImageIndex(0);
  }, []);

  const showNextImage = useCallback(() => {
    setSelectedImageIndex((prev) => {
      if (!selectedProduct) return prev;
      const total = selectedProduct.images.length;
      return total ? (prev + 1) % total : prev;
    });
  }, [selectedProduct]);

  const showPrevImage = useCallback(() => {
    setSelectedImageIndex((prev) => {
      if (!selectedProduct) return prev;
      const total = selectedProduct.images.length;
      return total ? (prev - 1 + total) % total : prev;
    });
  }, [selectedProduct]);

  const handleSelectImage = useCallback((index) => {
    setSelectedImageIndex(index);
  }, []);

  return (
    <div className="all-products-page">
      <GlobalLoader />
      <Header standalone />
      <main className="all-products-content">
        <div className="all-products-container">
          <div className="all-products-heading">
            <h1>Todos los productos</h1>
            <p>Explora el catálogo completo de Agrik y encuentra la opción ideal para tu cultivo.</p>
          </div>
          <div className="all-products-grid">
            {products.map((product) => (
              <button
                type="button"
                className="all-product-card"
                key={product.id}
                onClick={() => openProductModal(product)}
              >
                <img src={product.images[0]} alt={product.label} loading="lazy" />
                <p className="all-product-card__label">{product.label}</p>
              </button>
            ))}
          </div>
          <p><br></br><br></br><br></br></p>
          <button type="button" className="download-button" data-bs-toggle="modal" data-bs-target="#downloadModal">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="4"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Descargar catálogo<br></br>de productos
          </button>
        </div>
      </main>
      {selectedProduct && (
        <ProductModal
          product={selectedProduct}
          currentImageIndex={selectedImageIndex}
          onClose={closeProductModal}
          onNext={showNextImage}
          onPrev={showPrevImage}
          onSelectImage={handleSelectImage}
          description={selectedProduct.description}
        />
      )}
      <Modal />
      <Footer />
    </div>
  );
};

export default AllProductsPage;
